export default __webpack_public_path__ + "static/media/Dive3.90f63351.png";